export default [
  {
    chapter: 1,
    thema: 1,
    name: "Flumen",
  },
  {
    chapter: 2,
    thema: 1,
    name: "Lupa",
  },
  {
    chapter: 3,
    thema: 1,
    name: "Regnum",
  },
  {
    chapter: 4,
    thema: 1,
    name: "Capitolium",
  },
  {
    chapter: 5,
    thema: 1,
    name: "Ignis Vestae",
  },
  {
    chapter: 6,
    thema: 1,
    name: "Castor et Pollux",
  },
  {
    chapter: 7,
    thema: 1,
    name: "Numen deorum",
  },
  {
    chapter: 8,
    thema: 2,
    name: "Triumphus",
  },
  {
    chapter: 9,
    thema: 2,
    name: "Gladiatores",
  },
  {
    chapter: 10,
    thema: 2,
    name: "Spectacula",
  },
  {
    chapter: 11,
    thema: 2,
    name: "Pugna",
  },
  {
    chapter: 12,
    thema: 2,
    name: "Circus Maximus",
  },
  {
    chapter: 13,
    thema: 2,
    name: "Theatrum",
  },
  {
    chapter: 14,
    thema: 2,
    name: "Spectatores",
  },
  {
    chapter: 15,
    thema: 3,
    name: "Matrona",
  },
  {
    chapter: 16,
    thema: 3,
    name: "Toga virilis",
  },
  {
    chapter: 17,
    thema: 3,
    name: "Funus",
  },
  {
    chapter: 18,
    thema: 3,
    name: "Servi",
  },
  {
    chapter: 19,
    thema: 3,
    name: "Fugitivus",
  },
  {
    chapter: 20,
    thema: 3,
    name: "Spartacus",
  },
  {
    chapter: 21,
    thema: 3,
    name: "Patronus",
  },
  {
    chapter: 22,
    thema: 4,
    name: "Pictura",
  },
  {
    chapter: 23,
    thema: 4,
    name: "Thermopolium",
  },
  {
    chapter: 24,
    thema: 4,
    name: "Triclinium",
  },
  {
    chapter: 25,
    thema: 4,
    name: "Fullonia",
  },
  {
    chapter: 26,
    thema: 4,
    name: "Pistrina",
  },
  {
    chapter: 27,
    thema: 4,
    name: "Thermae",
  },
  {
    chapter: 28,
    thema: 4,
    name: "Vesuvius",
  },
  {
    chapter: 29,
    thema: 5,
    name: "Hannibal",
  },
  {
    chapter: 30,
    thema: 5,
    name: "Ad portas",
  },
  {
    chapter: 31,
    thema: 5,
    name: "Scipio",
  },
  {
    chapter: 32,
    thema: 5,
    name: "Alexander",
  },
  {
    chapter: 33,
    thema: 5,
    name: "Alexandria",
  },
  {
    chapter: 34,
    thema: 5,
    name: "Philosophus",
  },
  {
    chapter: 35,
    thema: 5,
    name: "Graecia capta",
  },
  {
    chapter: 36,
    thema: 6,
    name: "Bellum Gallicum",
  },
  {
    chapter: 37,
    thema: 6,
    name: "Alesia",
  },
  {
    chapter: 38,
    thema: 6,
    name: "Vercingetorix",
  },
  {
    chapter: 39,
    thema: 6,
    name: "Alea iacta est",
  },
  {
    chapter: 40,
    thema: 6,
    name: "Veni vidi vici",
  },
  {
    chapter: 41,
    thema: 6,
    name: "Idus Martiae",
  },
  {
    chapter: 42,
    thema: 6,
    name: "Galli",
  },
  {
    chapter: 43,
    thema: 7,
    name: "Livia",
  },
  {
    chapter: 44,
    thema: 7,
    name: "Claudius",
  },
  {
    chapter: 45,
    thema: 7,
    name: "Nero",
  },
  {
    chapter: 46,
    thema: 7,
    name: "Flavii",
  },
  {
    chapter: 47,
    thema: 7,
    name: "Traianus",
  },
  {
    chapter: 48,
    thema: 7,
    name: "Constantinus",
  },
  {
    chapter: 49,
    thema: 7,
    name: "Sine ira et studio",
  },
  {
    chapter: 50,
    thema: 8,
    name: "Provincia",
  },
  {
    chapter: 51,
    thema: 8,
    name: "Opera publica",
  },
  {
    chapter: 52,
    thema: 8,
    name: "Diploma",
  },
  {
    chapter: 53,
    thema: 8,
    name: "Limes",
  },
  {
    chapter: 54,
    thema: 8,
    name: "Julius Civilis",
  },
  {
    chapter: 55,
    thema: 8,
    name: "Batavi",
  },
  {
    chapter: 56,
    thema: 8,
    name: "Germania",
  },
];



// WEBPACK FOOTER //
// ./src/data/opbouw-spqr.js